const config = {
  app: 'matchmaker',
  client_type: 'web',
  page_type: 'signup_lp',
};

export default config;
